import { Dispute } from 'APIs/disputes/disputes.types';
import { ForceDisputeOutcomeRequest } from 'APIs/transactions/transactions.types';

export type SetDisputeOutcomeFormProps = {
  disputeId: string;
  disputeOutcome: 'pending' | 'won' | 'lost';
  state?: string;
  reverseDisputeFees: boolean;
};

type ToForceDisputeOutcomeRequest = (setDisputeOutcomeForm: SetDisputeOutcomeFormProps) => ForceDisputeOutcomeRequest;
type ToSetDisputeOutcomeFormProps = (dispute: Dispute) => SetDisputeOutcomeFormProps;

export const toForceDisputeOutcomeRequest: ToForceDisputeOutcomeRequest = (
  setDisputeOutcomeForm: SetDisputeOutcomeFormProps,
): ForceDisputeOutcomeRequest => {
  return {
    ForceDisputeOutcome: {
      disputeId: setDisputeOutcomeForm.disputeId,
      disputeWon: setDisputeOutcomeForm.disputeOutcome === 'won',
      state: setDisputeOutcomeForm.state,
      reverseDisputeFees:
        setDisputeOutcomeForm.disputeOutcome === 'won' ? setDisputeOutcomeForm.reverseDisputeFees : false,
    },
  };
};

export const toSetDisputeOutcomeFormProps: ToSetDisputeOutcomeFormProps = (
  dispute: Dispute,
): SetDisputeOutcomeFormProps => {
  return {
    disputeId: dispute.disputeId,
    disputeOutcome: dispute.outcome as 'pending' | 'won' | 'lost',
    state: dispute.state,
    reverseDisputeFees: false,
  };
};

export const disputeOutcomes = {
  pending: { label: 'Pending', className: 'label-pending' },
  won: { label: 'Won', className: 'label-won' },
  lost: { label: 'Lost', className: 'label-lost' },
};
